import { render, staticRenderFns } from "./PopupRejectGuestOnArrival.vue?vue&type=template&id=32b1c8c0&scoped=true&"
import script from "./PopupRejectGuestOnArrival.vue?vue&type=script&lang=js&"
export * from "./PopupRejectGuestOnArrival.vue?vue&type=script&lang=js&"
import style0 from "./PopupRejectGuestOnArrival.vue?vue&type=style&index=0&id=32b1c8c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b1c8c0",
  null
  
)

export default component.exports